import { useEffect } from 'react';

type PropsLike = {
  model?: {
    dataLayerStaticElements?: {
      site_id?: string | null;
      site_language?: string | null;
      env_platform?: string | null;
    };
  };
};

export function usePageView(props: PropsLike) {
  useEffect(() => {
    const siteId = props?.model?.dataLayerStaticElements?.site_id ?? 'Love Travels';
    const languageDomain = props?.model?.dataLayerStaticElements?.site_language ?? 'US';
    const platform = props?.model?.dataLayerStaticElements?.env_platform ?? 'Phoenix';

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const adobeDataLayer = (window as any).adobeDataLayer || [];

    adobeDataLayer.push({
      event: 'PAGEVIEW',
      metadata: {
        allow_marketing: false,
        site_id: siteId,
        language_domain: languageDomain,
        platform: platform,
      },
      page: {
        name: window.location.hostname + window.location.pathname,
        url: window.location.host + window.location.pathname + window.location.search + window.location.hash,
      },
      user: {
        alt_customer_id: null,
        authentication_status: 'Unauthenticated',
      },
    });
  }, []);
}
